<template>
  <div class="language-input__container">
    <label
      id="lanuage-input"
      for="language input"
      class="language-input__label"
    >
      <p>{{ $t("LanguageInput.label.selectLanguage") }}</p>
    </label>

    <div
      class="language-input"
      @click="handleInputFocus($event)"
      :class="{ isFocused: isFocused }"
    >
      <DropdownSelect
        :isOpen="isOpen"
        :hasOneItemOnly="listHasOneItem"
        class="dropdown-select"
        @click="toggleSelect()"
        @onClickOutside="handleClickOutside"
      >
        <template #selectedItem>
          <template v-if="selectedSingle">
            <span
              id="dropdownSelectedItemRef"
              class="dropdown-select__selected-item"
              @keydown.enter="toggleSelect(false)"
              @keydown.space="toggleSelect(false)"
              tabindex="0"
            >
              <GlobeCircle class="dropdown-select__icon" />
              <span class="dropdown-select__selected-item__text">{{
                selectedSingle.name
              }}</span>
            </span>
          </template>
        </template>
        <template #dropdownOptions>
          <SelectList
            @onClickOutside="handleClickOutside"
            :items="selectList"
            :counterIndex="counterIndex"
            :isOpen="isOpen"
            id="dropdownSelectListRef"
            @click="toggleSelect()"
            @selectElement="handleLanguageChangeSelect"
            @selectElOnClick="handleLanguageChangeSelectClick"
            @moveToNextElement="goToNextEl()"
            @moveToPreviousElement="goToPreviousEl()"
            @close="toggleSelect(false)"
          >
            <template #selectItem="{ item }">
              <span class="select-list__text">{{ item?.name }}</span>
            </template>
          </SelectList>
        </template>
      </DropdownSelect>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import DropdownSelect from "@/components/ui/selects/DropdownSelect.vue";
import SelectList from "@/components/ui/selects/SelectList.vue";
import useSelectList from "@/composables/ui/useSelectList";
import {
  LOCALES,
  switchLanguage,
  getPersistedLocale,
  selectedLocale,
} from "@/packages/i18n/translation";

import { useGlobalStore } from "@/stores/globalStore";
import GlobeCircle from "@/components/icons/GlobeCircle.vue";

const globalStore = useGlobalStore();

const isFocused = ref(false);

const {
  isOpen,
  counterIndex,
  selectList,
  goToNextEl,
  selectEl,
  selectElOnClick,
  goToPreviousEl,
  selectedSingle,
  toggleSelect,
  listHasOneItem,
  handleClickOutside,
} = useSelectList({
  items: LOCALES,
});
const handleLanguageChangeSelect = (val) => {
  switchLanguage(val.value);
  selectEl(val);
};

const handleLanguageChangeSelectClick = (val) => {
  switchLanguage(val.value);
  selectElOnClick(val);
};

const handleInputFocus = (e) => {
  if (e.target.className === "language-input") {
    const childInput = e.target.querySelector("input");
    childInput.focus();
  }
};

onMounted(async () => {
  const currentLocale = getPersistedLocale();
  selectElOnClick(selectedLocale());
  await switchLanguage(currentLocale);
});
</script>

<style lang="scss">
.language-input {
  position: relative;

  padding: 1rem;
  display: flex;
  grid-template-columns: 3fr 0.5fr;
  align-items: center;
  border-radius: 1rem;
  background: var(--input-background);
  margin-bottom: calc($formFieldSpacing/2);
  position: relative;

  &__label p {
    margin-left: $padding-sml;
    margin-bottom: 0.5rem;
  }

  .dropdown-select {
    padding-left: $padding-std;

    &__selected-item__text {
      padding-left: $padding-std;
    }
  }
}
</style>
